<template>
	<div>
		<modalconfirm ref="modalconfirmSO" @action="proccessSO"></modalconfirm>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Sales Order Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="grey lighten-3" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link v-if="hasAccess('add-sales-order')" :to="{ name: 'add-sales-order' }">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Sales Order</div>
							</v-btn>
						</router-link>
						<div class="ml-4">
							<v-tabs color="primary" background-color="grey lighten-3" class="change-display" height="40">
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col cols="12" class="px-4 pb-1">
						<v-row>
							<v-col cols="12" md="4">
								<v-text-field dense outlined hide-details label="Kode SO" v-model="codeSO.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-menu v-model="menuDateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalDibuat)" label="Tanggal Dibuat" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalDibuat"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-menu v-model="menuDatePay" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalDibayar)" label="Tanggal Dibayar" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalDibayar"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete item-text="" outlined dense hide-details v-model="statusSO.value" :items="OptionStatus" label="Status SO" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										{{item | toStatusSOWH}}
									</template>
									<template v-slot:selection = {item}>
										{{item | toStatusSOWH}}
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field dense outlined hide-details label="Kode Pelanggan(MB)" v-model="codeMB.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field dense outlined hide-details label="Nama Pelanggan" v-model="nameMB.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="customer_province.value" :items="ProvinceOption" label="Provinsi" item-text="province" item-value="province_id" no-data-text="Tidak ada data yang sesuai" @change="changeProvince">
									<template v-slot:item = {item}>
										<span v-if="item.province_id">Provinsi {{ item.province }}</span>
										<span v-else>{{ item.province }}</span>
									</template>
									<template v-slot:selection = {item}>
										<span v-if="item.province_id">Provinsi {{ item.province }}</span>
										<span v-else>{{ item.province }}</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="customer_city.value" :items="CityOption" label="Kota" placeholer="ini kota" item-text="city_name" item-value="city_id" no-data-text="Tidak ada data yang sesuai" @change="changeCity">
									<template v-slot:item = {item}>
										<span v-if="item.city_id">{{ item.type }} {{ item.city_name }}</span>
										<span v-else>{{ item.city_name }}</span>
									</template>
									<template v-slot:selection = {item}>
										<span v-if="item.city_id">{{ item.type }} {{ item.city_name }}</span>
										<span v-else>{{ item.city_name }}</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="customer_subdistrict.value" :items="SubdistrictOption" label="Kecamatan" item-text="subdistrict_name" item-value="subdistrict_id" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										<span v-if="item.subdistrict_id">Kecamatan {{ item.subdistrict_name }}</span>
										<span v-else>{{ item.subdistrict_name }}</span>
									</template>
									<template v-slot:selection = {item}>
										<span v-if="item.subdistrict_id">Kecamatan {{ item.subdistrict_name }}</span>
										<span v-else>{{ item.subdistrict_name }}</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="so_warehouse.value" :items="warehouseResults" label="Warehouse" item-text="warehouse_name" item-value="warehouse_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete outlined dense hide-details v-model="orderFromSO.value" :items="soOrderFrom" label="Asal Transaksi" item-text="text" item-value="value" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="8" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div v-if="!cardDisplay">
				<v-card outlined class="mt-3" v-if="listSO.length > 0">
					<template>
						<v-data-table hide-default-footer disable-pagination class="white-row custom-table table-w-120" :headers="headers" :items="listSO" :options.sync="option" :server-items-length="soPagination.total_data" :single-expand="false" :expanded.sync="expanded" item-key="so_code" :show-expand="true">
							<template v-slot:item.action="{ item }">
								<div class="py-2">
									<v-tooltip bottom v-if="false">
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="mr-1" fab dark x-small depressed color="primary lighten-1" v-bind="attrs" v-on="on" @click.stop="printSO(item.so_warehouse_id, item.so_code)">
												<v-icon dark>mdi-printer</v-icon>
											</v-btn>
										</template>
										<span>Print</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.so_code)">
												<v-icon dark>mdi-text-box-search</v-icon>
											</v-btn>
										</template>
										<span>Detail</span>
									</v-tooltip>
									<div v-show="(item.so_status == 'created' || item.so_status == 'canceled') && hasAccess('payment-sales-order')">
										<v-tooltip bottom v-if="item.so_status == 'created'">
											<template v-slot:activator="{ on, attrs }">
												<router-link class="text-deco" :to="{ name: 'payment-sales-order', params: { code: item.so_code }}">
													<v-btn class="mr-1 mt-1" fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
														<v-icon dark>mdi-check</v-icon>
													</v-btn>
												</router-link>
											</template>
											<span>Proses Pembayaran</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn @click.stop="hapus(item.so_id)" class="mt-1" fab dark x-small depressed color="pink lighten-2" v-bind="attrs" v-on="on">
													<v-icon dark>mdi-delete</v-icon>
												</v-btn>
											</template>
											<span>Hapus Pembelian</span>
										</v-tooltip>
									</div>
									<div v-show="item.so_status == 'paid' && hasAccess('payment-sales-order')">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn @click.stop="cancelPayment(item.so_id)" class="mt-1" fab dark x-small depressed color="pink lighten-2" v-bind="attrs" v-on="on">
													<v-icon dark>mdi-table-cancel</v-icon>
												</v-btn>
											</template>
											<span>Batalkan Pembayaran</span>
										</v-tooltip>
									</div>
									<div v-show="item.so_status == 'approved' && hasAccess('payment-sales-order')">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn @click.stop="cancelApproval(item.so_id)" class="mt-1" fab dark x-small depressed color="orange lighten-2" v-bind="attrs" v-on="on">
													<v-icon dark>mdi-cancel</v-icon>
												</v-btn>
											</template>
											<span>Batalkan Approval</span>
										</v-tooltip>
									</div>
									<div v-show="(item.so_status == 'approval_refund')">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<router-link class="text-deco" :to="{ name: 'approval-refund-sales-order', params: { code: item.so_code }}">
													<v-btn class="mr-1 mt-1" fab dark x-small depressed color="orange lighten-2" v-bind="attrs" v-on="on">
														<v-icon dark>mdi-progress-check</v-icon>
													</v-btn>
												</router-link>
											</template>
											<span>Approve Refund</span>
										</v-tooltip>
									</div>
								</div>
							</template>
							<template v-slot:item.so_status_created_datetime="{ item }">
								<div>{{ item.so_status_created_datetime | tanggaljam }}</div>
							</template>
							<template v-slot:item.so_status="{ item }">
								<div>{{ item.so_status | toStatusSOWH }}</div>
							</template>
							<template v-slot:item.so_from="{ item }">
								<div v-if="item.so_order_from == 'warehouse'">Warehouse - {{ item.so_status_created_user_name }}</div>
								<div v-if="item.so_order_from == 'pos'">PO Stockist - {{ item.so_status_created_user_name }}</div>
							</template>
							<template v-slot:item.customer_info="{ item }">
								<div class="py-2">
									<div class="d-flex">
										<div>{{ item.customer_network_code }}</div>
										<div class="px-1">-</div>
										<div>{{ item.customer_name }}</div>
										<div class="px-1">-</div>
										<div>{{ item.customer_mobilephone }}</div>
									</div>
									<div class="pt-1">{{ addressText(item) }}</div>
								</div>
							</template>
							<template v-slot:expanded-item="{ headers, item }">
								<td class="px-0" :colspan="headers.length">
									<v-card tile class="elevation-0">
										<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
											<template v-slot:default>
												<thead>
													<tr>
														<th width="20%" class="text-left">Nama Produk</th>
														<th width="20%" class="text-center">Jumlah Dipesan</th>
														<th width="20%" class="text-center">Jumlah Diterima</th>
														<th width="20%" class="text-center">Jumlah Dijalan</th>
														<th width="20%" class="text-center">Serial</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="product in item.so_detail" :key="product.so_detail_id">
														<td class="px-4 text-left">
															<div class="font-size-10">{{ product.so_detail_product_name }}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.so_detail_quantity_sold | toNumber }} {{product.so_detail_product_unit}}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.so_detail_quantity_received | toNumber }} {{product.so_detail_product_unit}}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.so_detail_quantity_transport | toNumber }} {{product.so_detail_product_unit}}</div>
														</td>
														<td class="px-4 text-center">
															<div class="font-size-10">{{ product.serial_string ? product.serial_string : '-' }}</div>
														</td>
													</tr>
												</tbody>
											</template>
										</v-simple-table>
									</v-card>
								</td>
							</template>
						</v-data-table>
					</template>
				</v-card>
			</div>
			<div v-if="cardDisplay">
				<v-row class="mr-0" v-if="listSO.length > 0">
					<v-col cols="12" md="12" class="pb-0 pr-0" v-for="listso in listSO" :key="listso.so_id">
						<v-card outlined>
							<v-list color="grey lighten-3" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Sales Order {{ listso.so_code }}
									</v-list-item-content>
									<v-spacer></v-spacer>
									<v-btn v-if="false" small text depressed class="primary" @click="printSO(listso.so_warehouse_id, listso.so_code)">
										<v-icon>mdi-printer</v-icon>
										<div class="pl-2 text-capitalize">Print</div>
									</v-btn>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Kode Pelanggan</div>
											<div class="subtitle-2">{{ listso.customer_network_code }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Nama Mitra</div>
											<div class="subtitle-2">{{ listso.customer_name }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Nomor Handphone</div>
											<div class="subtitle-2">{{ listso.customer_mobilephone }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 oppacity-75">Tanggal Transaksi</div>
											<div class="subtitle-2">{{ listso.so_status_created_datetime | tanggal }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 pt-4 pt-md-0 oppacity-75">Status</div>
											<div class="subtitle-2">{{ listso.so_status | toStatusSOWH }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 pt-4 pt-md-0 oppacity-75">Asal Transaksi</div>
											<div v-if="listso.so_order_from == 'warehouse'" class="subtitle-2">Warehouse - {{ listso.so_status_created_user_name }}</div>
											<div v-if="listso.so_order_from == 'pos'" class="subtitle-2">PO Stockist - {{ listso.so_status_created_user_name }}</div>
										</v-flex>
										<v-flex xs6 sm3 md2 class="pr-3">
											<div class="body-2 pt-4 oppacity-75">Warehouse</div>
											<div v-if="listso.warehouse_name" class="subtitle-2">{{ listso.warehouse_name }}</div>
											<div v-else>-</div>
										</v-flex>
										<v-flex xs6 sm6 md6 class="pr-3">
											<div class="body-2 pt-4 oppacity-75">Alamat</div>
											<div class="subtitle-2">{{ addressText(listso) }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3 class="pr-3 pt-1">
											<div class="pt-5">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(listso.so_code)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
												<span v-show="(listso.so_status == 'created' || listso.so_status == 'canceled') && hasAccess('payment-sales-order')">
													<v-tooltip bottom v-if="listso.so_status == 'created'">
														<template v-slot:activator="{ on, attrs }">
															<router-link class="text-deco" :to="{ name: 'payment-sales-order', params: { code: listso.so_code }}">
																<v-btn class="mr-2" fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on">
																	<v-icon dark>mdi-check</v-icon>
																</v-btn>
															</router-link>
														</template>
														<span>Proses Pembayaran</span>
													</v-tooltip>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn @click.stop="hapus(listso.so_id)" class="mr-2" fab dark x-small depressed color="pink lighten-2" v-bind="attrs" v-on="on">
																<v-icon dark>mdi-delete</v-icon>
															</v-btn>
														</template>
														<span>Hapus Pembelian</span>
													</v-tooltip>
												</span>
												<span v-show="listso.so_status == 'paid' && hasAccess('payment-sales-order')">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn @click.stop="cancelPayment(listso.so_id)" class="mr-2" fab dark x-small depressed color="pink lighten-2" v-bind="attrs" v-on="on">
																<v-icon dark>mdi-table-cancel</v-icon>
															</v-btn>
														</template>
														<span>Batalkan Pembayaran</span>
													</v-tooltip>
												</span>
												<span v-show="listso.so_status == 'approved' && hasAccess('payment-sales-order')">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn @click.stop="cancelApproval(listso.so_id)" class="mr-2" fab dark x-small depressed color="orange lighten-2" v-bind="attrs" v-on="on">
																<v-icon dark>mdi-cancel</v-icon>
															</v-btn>
														</template>
														<span>Batalkan Approval</span>
													</v-tooltip>
												</span>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-2">
								<v-card tile elevation="0">
									<v-data-table :headers="headersProduct" :items="listso.so_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.so_detail_quantity_sold="{ item }">
											<div>{{ item.so_detail_quantity_sold | toNumber }} {{item.so_detail_product_unit}}</div>
										</template>
										<template v-slot:item.so_detail_quantity_received="{ item }">
											<div>{{ item.so_detail_quantity_received | toNumber }} {{item.so_detail_product_unit}}</div>
										</template>
										<template v-slot:item.so_detail_quantity_transport="{ item }">
											<div>{{ item.so_detail_quantity_transport | toNumber }} {{item.so_detail_product_unit}}</div>
										</template>
										<template v-slot:item.serial_string="{ item }">
											<div>{{ item.serial_string ? item.serial_string : '-' }}</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<v-card class="mt-3" outlined v-if="listSO.length == 0 && soPagination">
				<div class="py-3">
					<not-found></not-found>
				</div>
			</v-card>
			<div class="pt-5">
				<v-row v-if="soPagination">
					<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
						<span>Total {{soPagination.total_data | toNumber}} Data</span>
						<v-pagination v-model="page" :length="soPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus" @input="changePage"></v-pagination>
					</v-col>
					<v-col cols="1" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" @input="changeLimit"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'
import modalDetail from '@/views/MLwarehouse/so/DetailSO'
import modalPrint from '@/views/MLwarehouse/so/ModalPrintSO'

export default {
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: false,
			expanded: [],
			dialog: false,
			dialogPrint: false,
			dropfilter: false,
			menuDateCreate: false,
			menuDatePay: false,
			loading: true,
			soProccess: '',
			soProccessID: '',
			tanggalDibuat: [],
			tanggalDibayar: [],
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			params:[],
			headers: [
			{ text: 'Aksi', value: 'action', align: 'left', width: '9%', sortable: false },
			{ text: 'Kode Sales Order', value: 'so_code', width: '15%', sortable: true },
			{ text: 'Tanggal Transaksi', value: 'so_status_created_datetime', width: '15%', sortable: true },
			{ text: 'Status', value: 'so_status', width: '15%', sortable: true },
			{ text: 'Warehouse', value: 'warehouse_name', width: '10%', sortable: true },
			{ text: 'Asal Transaksi', value: 'so_from', width: '15%', sortable: false },
			{ text: 'Info Pelanggan', value: 'customer_info', width: '33%', sortable: false },
			],
			headersProduct: [
			{ text: 'Nama Produk', value: 'so_detail_product_name', sortable: false },
			{ text: 'Jumlah Dipesan', value: 'so_detail_quantity_sold', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'so_detail_quantity_received', sortable: false, align: 'center' },
			{ text: 'Jumlah Dijalan', value: 'so_detail_quantity_transport', sortable: false, align: 'center' },
			{ text: 'Serial', value: 'serial_string', sortable: false },
			],
			codeSO: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'so_code'
			},
			codeMB: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'customer_network_code'
			},
			nameMB: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'customer_name'
			},
			dateCreatedSO: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'so_status_created_datetime'
			},
			datePaidSO: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'so_status_paid_datetime'
			},
			statusSO: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'so_status'
			},
			so_warehouse: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'so_warehouse_id'
			},
			customer_province: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'customer_province_id'
			},
			customer_city: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'customer_city_id'
			},
			customer_subdistrict: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'customer_subdistrict_id'
			},
			orderFromSO: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'so_order_from'
			},
			soOrderFrom: [
				{
					text: 'Warehouse',
					value: 'warehouse'
				}, {
					text: 'POS',
					value: 'pos',
				}
			],
		}
	},
	computed: {
		...mapState('so', ['listSO', 'soPagination', 'OptionStatus', 'warehouseResults', 'ProvinceOption', 'CityOption', 'SubdistrictOption']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('so', ['getSOAll', 'getOptionStatus', 'approvalPayment', 'cancelSO', 'deleteSO', 'cancelPaymentSO', 'cancelApprovalSO', 'getDetailSO', 'exportSOAll', 'getWarehouseOption', 'getProvinceOption', 'getOptionCity', 'getOptionSubdistrict']),
		...mapActions('common', ['getLetterHeader']),
		...mapMutations('so', ['clearDataSO']),
		...mapMutations(['setOverlay']),

		getData() {
			this.getSOAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData(){
			this.exportSOAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		cari() {
			this.params = []
			if(this.codeSO.value)
				this.params.push(this.codeSO)
			if(this.codeMB.value)
				this.params.push(this.codeMB)
			if(this.nameMB.value)
				this.params.push(this.nameMB)
			if (this.dateCreatedSO.value) {
				if (this.dateCreatedSO.value.length > 1) {
					this.dateCreatedSO.value.sort()
					let date = this.dateCreatedSO.value.join('::')
					this.dateCreatedSO.value = date
				}
				this.params.push(Object.assign({}, this.dateCreatedSO))
			}
			if (this.datePaidSO.value) {
				if (this.datePaidSO.value.length > 1) {
					this.datePaidSO.value.sort()
					let date = this.datePaidSO.value.join('::')
					this.datePaidSO.value = date
				}
				this.params.push(Object.assign({}, this.datePaidSO))
			}
			if (this.statusSO.value)
				this.params.push(this.statusSO)
			if (this.so_warehouse.value)
				this.params.push(this.so_warehouse)
			if (this.customer_province.value)
				this.params.push(this.customer_province)
			if (this.customer_city.value)
				this.params.push(this.customer_city)
			if (this.customer_subdistrict.value)
				this.params.push(this.customer_subdistrict)
			if (this.orderFromSO.value)
				this.params.push(this.orderFromSO)
			this.getData()
		},
		resetFilter() {
			this.codeSO.value = ''
			this.codeMB.value = ''
			this.nameMB.value = ''
			this.tanggalDibuat = []
			this.tanggalDibayar = []
			this.statusSO.value = ''
			this.so_warehouse.value = ''
			this.customer_province.value = ''
			this.customer_city.value = ''
			this.customer_subdistrict.value = ''
			this.orderFromSO.value = ''
			this.params = []
			this.getData()
		},
		addressText(customer_data) {
			var data = []
			if (customer_data) {
				if (customer_data.customer_address)
					data.push(customer_data.customer_address)
				if (customer_data.customer_subdistrict_name)
					data.push(customer_data.customer_subdistrict_name)
				if (customer_data.customer_city_name)
					data.push(customer_data.customer_city_name)
				if (customer_data.customer_province_name)
					data.push(customer_data.customer_province_name)
			}
			return data.join(', ')
		},
		hapus(val) {
			let msg = "Yakin ingin menghapus Sales Order ini?"
			this.soProccess = "delete"
			this.soProccessID = val
			this.$refs.modalconfirmSO.setMessage(msg)
			this.$refs.modalconfirmSO.showConfirm()
		},
		cancelPayment(val) {
			let msg = "Yakin ingin membatalkan pembayaran Sales Order ini?"
			this.soProccess = "cancelPayment"
			this.soProccessID = val
			this.$refs.modalconfirmSO.setMessage(msg)
			this.$refs.modalconfirmSO.showConfirm()
		},
		cancelApproval(val) {
			let msg = "Yakin ingin membatalkan approval Sales Order ini?"
			this.soProccess = "cancelApproval"
			this.soProccessID = val
			this.$refs.modalconfirmSO.setMessage(msg)
			this.$refs.modalconfirmSO.showConfirm()
		},
		async proccessSO(){
			await this.setOverlay(true)
			await this.$refs.modalconfirmSO.hideConfirm()
			if (this.soProccess == 'pay') {
				await this.approvalPayment(this.soProccessID)
			} else if (this.soProccess == 'cancel') {
				await this.cancelSO(this.soProccessID)
			} else if (this.soProccess == 'delete') {
				await this.deleteSO(this.soProccessID)
			} else if (this.soProccess == 'cancelPayment') {
				await this.cancelPaymentSO(this.soProccessID)
			} else if (this.soProccess == 'cancelApproval') {
				await this.cancelApprovalSO(this.soProccessID)
			}
			await this.getData()
			await this.setOverlay(false)
		},
		getDetail(code){
			this.getDetailSO(code).then(()=> {
				this.dialog = true
			})
		},
		async printSO(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailSO(code).then(()=> {
				this.dialogPrint = true
			})
		},
		changeProvince() {
			this.getOptionCity({
				province_id: this.customer_province.value
			})
			this.customer_city.value = ''
			this.customer_subdistrict.value = ''
		},
		changeCity() {
			this.getOptionSubdistrict({
				city_id: this.customer_city.value
			})
			this.customer_subdistrict.value = ''
		},
	},
	async created() {
		await this.getWarehouseOption()
		await this.getProvinceOption()
		await this.getOptionStatus()
		await this.getData()
		this.loading = await false
		this.$store.dispatch('setPageTitle', `Sales Order`)
	},
	beforeDestroy(){
		this.clearDataSO()
	},
	watch: {
		tanggalDibuat(val) {
			this.dateCreatedSO.value = val
		},
		tanggalDibayar(val) {
			this.datePaidSO.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		},
	}
};
</script>